import { PayOffDebtGoal } from '@common/goals';
import { getGoalBaseConfig } from '@common/react/goals';
import { getRecommendedRiskScoreUsingTargetDate } from '../helpers';
import { GoalConfig } from './types';

export const PAY_OFF_DEBT: GoalConfig<PayOffDebtGoal> = {
    inputSteps: [
        // TODO
    ],
    getGoalStatementContent: () => {
        // TODO
        return null;
    },
    getAssumptionsContent: () => (
        // TODO
        <></>
    ),
    getRecommendedRiskScore: (config) =>
        getRecommendedRiskScoreUsingTargetDate(config),
    getTargetDate: ({ goalData }) => goalData.targetDate,
    ...getGoalBaseConfig('PAY_OFF_DEBT'),
};
